<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="formData" :rules="rules" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="车牌号" prop="vehicleKey">
              <el-input v-model="formData.vehicleKey" placeholder="请输入车牌号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机姓名" prop="driverName">
              <el-input v-model="formData.driverName" placeholder="请输入司机姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机身份证" prop="driverKey">
              <el-input v-model="formData.driverKey" placeholder="请输入司机身份证" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机手机号" prop="driverMobile">
              <el-input v-model="formData.driverMobile" placeholder="请输入司机手机号" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="formData.remark" placeholder="请输入备注" type="textarea" rows="4" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="submit" class="global-button">保存</el-button>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { validIDCard, validPhoneNumber } from '@/utils/validator'

export default {
  name: 'VehicleBlackAdd',
  data() {
    return {
      formData: {
        vehicleKey: '', // 车牌号
        driverName: '', // 司机姓名
        driverKey: '', // 司机身份证
        driverMobile: '', // 司机手机号
        remark: '' // 备注
      },
      rules: {
        vehicleKey: [
          { required: true, message: '请输入车牌号', trigger: 'blur' }
        ],
        driverName: [
          { required: true, message: '请输入司机姓名', trigger: 'blur' }
        ],
        driverKey: [
          { required: true, message: '请输入司机身份证', trigger: 'blur' },
          { pattern: validIDCard, message: '请输入正确的司机身份证', trigger: 'blur' }
        ],
        driverMobile: [
          { required: true, message: '请输入司机手机号', trigger: 'blur' },
          { pattern: validPhoneNumber, message: '请输入正确的司机手机号', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    blacklistId() {
      return this.$route.query.blacklistId
    }
  },
  created() {
    if (this.blacklistId) {
      this.loadDetails()
    }
  },
  methods: {
    loadDetails() {
      this.$axios.get(this.$apis.vehicleBlack.selectWlVehicleBlacklistByBlacklistId, {
        params: { blacklistId: this.blacklistId }
      }).then(res => {
        this.formData = res
      })
    },
    submit() {
      this.$refs.formData.validate().then(() => {
        let url = this.$apis.vehicleBlack.insertWlVehicleBlacklist
        if (this.blacklistId) {
          url = this.$apis.vehicleBlack.updateWlVehicleBlacklist
        }
        this.$axios.post(url, this.formData).then(() => {
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.el-select,
.el-input,
.el-cascader {
  width: 95%;
}
</style>
